import React, { useEffect, useState } from "react";

import { collection, query, where, orderBy, limit, onSnapshot, documentId } from "firebase/firestore";
import { db } from "../../firebase";
import NotesContainerMobile from "../Notes/NotesContainerMobile";
import { CircularProgress } from "@mui/material";
import { useAuth } from "../../contexts/AuthContext";

function TherapyNoteContainerMobile(props) {
  const [notes, setNotes] = useState([]);
  const [loading, setLoading] = useState(true);
  const { currentUser } = useAuth();
  const [userRole, setUserRole] = useState(null);

  useEffect(() => {
    if (currentUser) {
      const userId = currentUser.uid;
      const q = query(
        collection(db, "roles"),
        where(documentId(), "==", userId)
      );

      const unsubscribe = onSnapshot(q, (querySnapshot) => {
        if (!querySnapshot.empty) {
          const role = querySnapshot.docs[0].data().role;
          setUserRole(role);
        } else {
          console.log("❌ Aucun rôle trouvé.");
          setUserRole(null);
        }
      });

      return () => unsubscribe();
    }
  }, [currentUser]);

  useEffect(() => {
    if (!props.clientId || !userRole) return; // Vérifie que tout est bien défini

    const notesRef = collection(db, "notes");
    let q;

    if (userRole === "Super Admin" || userRole === "Clinical Director") {
      q = query(
        notesRef,
        where("noteType", "==", "therapyNote"),
        where("clientId", "==", props.clientId),
        orderBy("effectiveDateTime", "desc"),
        limit(50)
      );
    } else if (userRole === "Therapist") {
      q = query(
        notesRef,
        where("noteType", "==", "therapyNote"),
        where("clientId", "==", props.clientId),
        //where("doneBy", "==", currentUser.displayName), // Filtre par le thérapeute connecté
        orderBy("effectiveDateTime", "desc"),
        limit(50)
      );
    } else {
      console.log(
        "⚠️ Rôle non autorisé pour voir les therapyNotes :",
        userRole
      );
      setNotes([]); // Empêche l'affichage des notes pour un rôle non autorisé
      return;
    }

    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const notesData = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      setLoading(false);
      setNotes(notesData);
    });

    return () => unsubscribe();
  }, [props.clientId, userRole]);

  return (
    <div className="notes-container-global">
      {loading ? (
        <div style={{ textAlign: "center" }}>
          <CircularProgress />
          <p>Loading, please wait...</p>
        </div>
      ) : (
        notes.map((note) => {
          const dateOptions = {
            day: "numeric",
            month: "short",
            year: "numeric",
          };

          const dateOptions2 = {
            day: "numeric",
            month: "short",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
          };

          const timeOptions = {
            hour: "2-digit",
            minute: "2-digit",
          };

          const formattedTimestamp = note.createdAt
            ? new Intl.DateTimeFormat("en-EN", dateOptions2).format(
                note.createdAt.toDate()
              )
            : "";

          const formattedDate = note.effectiveDateTime
            ? new Intl.DateTimeFormat("en-EN", dateOptions).format(
                note.effectiveDateTime.toDate()
              )
            : "";

          const formattedLastModification = note.updateAt
            ? new Intl.DateTimeFormat("en-EN", dateOptions2).format(
                note.updateAt.toDate()
              )
            : "";

          const formattedTime = note.effectiveDateTime
            ? new Intl.DateTimeFormat("en-EN", timeOptions).format(
                note.effectiveDateTime.toDate()
              )
            : "";

          return (
            <NotesContainerMobile
              key={note.id}
              noteContent={note.noteContent}
              effectiveDate={note.effectiveDateTime}
              noteDate={formattedDate}
              noteTime={formattedTime}
              doneBy={note.doneBy}
              timeStamp={formattedTimestamp}
              lastModification={formattedLastModification}
              clientPic={note.clientProfilePicture}
              clientFirstName={note.clientFirstName}
              clientLastName={note.clientLastName}
              noteId={note.id}
              {...note}
            />
          );
        })
      )}
    </div>
  );
}

export default TherapyNoteContainerMobile;
